import React from "react";

import { css } from "@emotion/react";
import styled from "@emotion/styled";

import useStore from "../../pages/GasStations/GasStation/store";
import LoadingIndicator from "../LoadingIndicator";
import Margin from "../Margin";
import PriceCard from "./PriceCard";
import * as styles from "./style.module.scss";

const Container = styled.div`
    margin: 20px 0;
    ${({ theme }) => theme.paddings.containerOuter.left}
    ${({ theme }) => theme.paddings.containerOuter.right}
`;

const InnerContainer = styled.div`
    padding-top: 20px;
    padding-bottom: 20px;
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    justify-content: space-between;
    ${({ theme }) => css`
        ${theme.breakpoints.from.medium.css`
         justify-content: unset;
      `}
    `}
`;

const InfoContainer = styled.div`
    color: ${({ theme }) => theme.colors.blue.toString()};
`;

const Headline = styled.h2`
    font-size: 2rem;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.red.toString()};
`;

const StyledP = styled.p`
    font-size: 0.7rem;
`;

const LoadingIndicatorWrapper = styled.div`
    margin: 20px 0;
`;

const PriceCards = ({ headline = "Aktuelle Preise" }) => {
    const { prices, gasStation, isLoading } = useStore();

    if (isLoading("prices")) {
        return (
            <Container>
                <LoadingIndicatorWrapper>
                    <LoadingIndicator inline>
                        Preise werden geladen...
                    </LoadingIndicator>
                </LoadingIndicatorWrapper>
            </Container>
        );
    }

    return (
        <Container>
            <Headline>{headline}</Headline>
            {!prices &&
                "Für diese Tankstelle stehen keine Daten zur Verfügung."}
            <>
                {prices && prices.preise && prices.preise.length > 0 && (
                    <Prices prices={prices} />
                )}
                {prices?.fail === true &&
                    gasStation.kraftstoffe &&
                    gasStation.kraftstoffe.length > 0 && (
                        <Margin top="20">
                            <GasProducts products={gasStation.kraftstoffe} />
                        </Margin>
                    )}
            </>
        </Container>
    );
};

const Prices = ({ prices }) => {
    return (
        <>
            <InnerContainer>
                {prices.preise.map((item, index) => {
                    return <PriceCard key={index} item={item} />;
                })}
            </InnerContainer>
            <InfoContainer>
                {prices.gesetzlicher_text.split("\n").map((item, index) => (
                    <StyledP key={index}>{item.trim()}.</StyledP>
                ))}
            </InfoContainer>
        </>
    );
};

const GasProducts = ({ products }) => {
    return (
        <>
            {products.map((product, index) => {
                return (
                    <div key={index} className={styles.gasProduct}>
                        <div className={styles.gasProductIconWrapper}>
                            <img
                                className={styles.gasProductIcon}
                                src={product.kraftstoffe_icon}
                                alt={product.kraftstoffe_name}
                            />
                        </div>{" "}
                        {product.kraftstoffe_name}
                    </div>
                );
            })}
        </>
    );
};

export default PriceCards;
